import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import axios from 'axios';
import { toast } from 'sonner';
import { Eye, EyeOff, Lock, User } from 'lucide-react';

const Login = () => {
  const navigate = useNavigate();
  const { login, user } = useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });

  useEffect(() => {
    if (user) {
      navigate('/');
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post('/auth/login', {
        username: formData.username,
        password: formData.password
      });

      if (response.data.access_token && response.data.user) {
        login(response.data.access_token, response.data.user);
        toast.success('Giriş başarılı!');
      } else {
        throw new Error('Invalid response data - missing token or user');
      }
    } catch (error) {
      console.error('Login error:', error);
      const errorMessage = error.response?.data?.detail ||
                          error.message ||
                          'Giriş yapılamadı. Lütfen tekrar deneyin.';
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F7F9] p-4 font-manrope">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-3xl border border-[#EBEEF2] p-8 sm:p-10" style={{ boxShadow: '0 18px 50px rgba(16,30,50,0.10)' }}>
          <div className="text-center mb-9">
            <div className="inline-flex w-14 h-14 bg-black rounded-2xl items-center justify-center mb-5">
              <span className="text-white font-extrabold text-xl tracking-tighter">P</span>
            </div>
            <h1 className="text-2xl font-extrabold tracking-tighter text-black">PROGOFILOAI</h1>
            <p className="text-sm text-[#8A95A1] font-medium mt-1">Fleet Management Software</p>
            <div className="w-9 h-[3px] rounded-full bg-[#B08D57] mx-auto mt-4" />
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="text-xs font-bold text-black mb-1.5 inline-block">
                Kullanıcı Adı
              </label>
              <div className="relative">
                <User className="absolute left-3.5 top-1/2 transform -translate-y-1/2 text-[#9AA6B2]" size={18} />
                <input
                  data-testid="username-input"
                  type="text"
                  value={formData.username}
                  onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                  className="w-full pl-11 pr-4 py-3 bg-white border border-[#EBEEF2] rounded-xl text-sm text-black placeholder:text-[#9AA6B2] focus:outline-none focus:ring-2 focus:ring-black/10 focus:border-black transition-shadow"
                  placeholder="kullaniciadi"
                  required
                  autoComplete="username"
                />
              </div>
            </div>

            <div>
              <label className="text-xs font-bold text-black mb-1.5 inline-block">
                Şifre
              </label>
              <div className="relative">
                <Lock className="absolute left-3.5 top-1/2 transform -translate-y-1/2 text-[#9AA6B2]" size={18} />
                <input
                  data-testid="password-input"
                  type={showPassword ? 'text' : 'password'}
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  className="w-full pl-11 pr-12 py-3 bg-white border border-[#EBEEF2] rounded-xl text-sm text-black placeholder:text-[#9AA6B2] focus:outline-none focus:ring-2 focus:ring-black/10 focus:border-black transition-shadow"
                  placeholder="••••••••"
                  required
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  data-testid="toggle-password-visibility"
                  className="absolute right-3.5 top-1/2 transform -translate-y-1/2 text-[#9AA6B2] hover:text-black transition-colors"
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            <button
              data-testid="login-button"
              type="submit"
              disabled={loading}
              className="w-full bg-black hover:bg-black/85 text-white font-semibold py-3 rounded-full transition-colors disabled:opacity-50 disabled:cursor-not-allowed active:scale-[0.98]"
            >
              {loading ? 'Yükleniyor...' : 'Giriş Yap'}
            </button>

            <div className="text-center">
              <button
                type="button"
                onClick={() => navigate('/forgot-password')}
                data-testid="forgot-password-link"
                className="text-sm text-[#8A95A1] hover:text-black font-medium transition-colors"
              >
                Şifremi Unuttum
              </button>
            </div>
          </form>
        </div>

        <div className="text-center mt-6 text-xs text-[#8A95A1] font-medium">
          <p>© 2025 PROGOFILOAI · Tüm hakları saklıdır.</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
